import React from 'react';
import { useTranslation } from 'react-i18next';
import { STYLES } from '../../consts';
import Heading from '../../../../../../generic-components/Heading';
import { VendorManager } from '../../../../../../components/VendorManager/pages';
import { useStore } from '../../../../../../store';

export const BillVendor = () => {
  const { t } = useTranslation();
  const billData = useStore(state => state.billData);
  return (
    <div className={STYLES.CREATE_BILL_BODY.BILL_AMOUNT.WRAPPER}>
      <Heading title={t('CREATE_BILL.VENDOR_NAME')} className={STYLES.CREATE_BILL_BODY.BILL_AMOUNT.TITLE} />
      <VendorManager initialVendorId={billData.supplierId} />
    </div>
  );
};
